export default axios => ({
  getFolderById: (projectId, folderId) => axios.get(`projects/${projectId}/documents/folders/${folderId}`).then(({ data }) => data.data),

  getProjectDocumentIndex: (projectId, payload) => axios.get(`projects/${projectId}/documents`, payload).then(({ data }) => data.data)
})
